import theme from '../../../../../lib/theme';

const {
  layouts,
  scale,
  media
} = theme;
export default () => ({
  container: {
    ...layouts.column,

    alignItems: 'center',
    padding: `0 ${scale.xs}`,

    [media.s.up]: {
      padding: `0 ${scale.s}`,
    },
  },

  form: {
    ...layouts.column,

    width: '100%',
    maxWidth: 600,
    paddingTop: scale.s,

    '& > *': {
      marginBottom: scale.s,
    },

    '& > *:last-child': {
      marginBottom: 0,
    },

    [media.l.up]: {
      ...layouts.row,

      alignItems: 'stretch',

      '& > *': {
        marginBottom: 0,
        marginRight: scale.s,
      },

      '& > *:last-child': {
        marginRight: 0,
      },
    },
  },

  typeahead: {
    flex: '1 0',
  },
});
